import React, { useMemo } from 'react';
import { Spin } from 'antd';
import { useGetAllIpPoolMappings } from 'query/domain';
import { Table } from 'components/ui';
import EditIPPoolCell from './components/EditIPPoolCell';

export default function ListIpPoolMappings() {
  const { data, isLoading } = useGetAllIpPoolMappings();

  const columns = useMemo(() => {
    return [
      {
        title: 'Sender Domain',
        dataIndex: 'senderDomain',
        key: 'senderDomain',
        width: 150,
      },
      {
        title: 'Receiver Service Provider',
        dataIndex: 'receiverProvider',
        key: 'receiverProvider',
        width: 250,
      },
      {
        title: 'ESP',
        dataIndex: 'esp',
        key: 'esp',
        width: 130,
      },
      {
        title: 'IP Pool Name',
        align: 'center',
        dataIndex: 'ipPool',
        key: 'ipPool',
        render: (value, row) => {
          return <EditIPPoolCell data={row} />;
        },
      },
    ];
  }, []);

  return (
    <Spin spinning={isLoading}>
      <Table
        columns={columns}
        dataSource={data || []}
        pageSize={15}
        rowKey="id"
      />
    </Spin>
  );
}
